import { render, staticRenderFns } from "./FormioFormBuilder.vue?vue&type=template&id=68ad1d23&scoped=true&"
import script from "./FormioFormBuilder.vue?vue&type=script&lang=js&"
export * from "./FormioFormBuilder.vue?vue&type=script&lang=js&"
import style0 from "./FormioFormBuilder.vue?vue&type=style&index=0&id=68ad1d23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ad1d23",
  null
  
)

export default component.exports